import React from 'react';
import { AppOverviewDataHooks } from '../data-hook';
import type { BenefitType } from '../../../components/benefit';
import { sizeConfig } from '../sizeConfig.const';
import { Box, Text, TextButton } from '@wix/design-system';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common/lazy';
import { useEssentials } from '../../../contexts/essentials-context';

interface AppOverviewContentProps {
  size: 'small' | 'large';
  benefits?: BenefitType[];
  description?: string;
  onLearnMoreClick?: () => void;
  appName: string;
}

const AppOverviewContent = ({
  size,
  benefits,
  description,
  onLearnMoreClick,
  appName,
}: AppOverviewContentProps) => {
  const { t } = useEssentials();

  const { textSize, benefitsMarginBottom } = sizeConfig[size];

  const benefitPaddingLeft = size === 'large' ? '30px' : '24px';

  return (
    <>
      <ul
        data-hook={AppOverviewDataHooks.BENEFITS_LIST}
        style={{ marginBottom: description ? benefitsMarginBottom : '0px' }}
      >
        {benefits?.map(
          (benefit, index) =>
            benefit.title && (
              <li key={index} style={{ paddingLeft: benefitPaddingLeft }}>
                {benefit.title}
              </li>
            ),
        )}
      </ul>

      {description && (
        <Text
          size={textSize}
          weight="thin"
          dataHook={AppOverviewDataHooks.LEAN_OVERVIEW_DESCRIPTION}
          className="text-description"
        >
          {description}
        </Text>
      )}

      {onLearnMoreClick && (
        <Box inline margin="3px 0 0 24px">
          <TextButton
            size="small"
            underline="always"
            onClick={onLearnMoreClick}
            suffixIcon={<ExternalLinkSmall />}
            dataHook={AppOverviewDataHooks.LEARN_MORE_BUTTON}
          >
            {t('app.page.overview.learnMore', {
              appName,
              interpolation: { escapeValue: false },
            })}
          </TextButton>
        </Box>
      )}
    </>
  );
};

export default AppOverviewContent;
